import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("dtl_admin_token");
export const setToken = (t) => {
  if (t) localStorage.setItem("dtl_admin_token", t);
  else localStorage.removeItem("dtl_admin_token");
};

export const adminApi = () =>
  axios.create({ baseURL: API, headers: { Authorization: `Bearer ${getToken()}` } });

export async function adminLogin(email, password) {
  const res = await axios.post(`${API}/auth/login`, { email, password });
  setToken(res.data.token);
  return res.data.user;
}

export async function adminLogout() {
  try { await adminApi().post("/auth/logout"); } catch { /* token may already be invalid */ }
  setToken(null);
}

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}
